module.exports = __webpack_public_path__ + "static/img/autumn_jianjiePic.a59f4049.png";